import * as chains from 'viem/chains'

export const viemChains = chains
export type ViemChain = (typeof viemChains)[keyof typeof viemChains]
